import {getCurrentLayout} from "../../appLayout";
import {
  getDistanceFromPointToInfiniteLine,
  getDistanceFromPointToLine,
  getIntersectCords,
  getMidPoint,
  getPointDistance,
  getPointField, isPointInsideShape,
  orientation
} from "./sqftHelper";
import workspace from "../components/canvas/core/workspace";
import sqftShape from "../components/canvas/core/shapes/sqftShape";
import sqftConfig from "../components/canvas/store/sqftConfig";
import store from "../../../store";
import {BACKSPLASH_LABELS, SHAPE_PART_ID, SQFT_APPLIANCES} from "../constants";
import {getRoomName} from "../../../misc/helpers";
import NumberText from "../components/canvas/core/workspace/text/numberText";
import SqftStore from "../components/canvas/store/sqftStore";
import workspaceControllers from "../components/canvas/store/workspaceControllers";
import Wall from "../components/canvas/core/shapes/wall";
import sqftImageManager from "../components/canvas/store/sqftImageManager";
import {getNavItemsFromTheWizard} from "./sqftHelperUi";
import {getIntersectionCordsV2} from "./coordinatesHelper";
import sqftEventManager from "../components/canvas/store/sqftEventManager";
import {getFontSizeFromContext} from "../components/canvas/store/canvasHelper";
import EventManager from "../components/canvas/store/sqftEventManager";
import ShapeResizeAutoShift from "../components/canvas/core/shapes/shapeParts/ShapeResizeAutoShift";

export const DIRECTIONS = {
  EAST: "east",
  WEST: "west",
  NORTH: "north",
  SOUTH: "south",
  NORTHEAST: "northeast",
  NORTHWEST: "northwest",
  SOUTHEAST: "southeast",
  SOUTHWEST: "southwest",
  UNDEFINED: "undefined"
};

export default class ShapeHelper {

  /**
   * @param {sqftShape} activeShape
   * @return {object} {sqftShape.id: [intersectionPoints]}
   */
  static getIntersectionsWithOtherShapes(activeShape) {
    let activeShapeLines = activeShape.getLines();
    let shapes = workspace.getShapes();
    let intersectionPoints = {};
    activeShapeLines.forEach((activeShapeLine) => {
      shapes.forEach(function(shape) {
        if (shape instanceof sqftShape && !shape.isHidden && shape.id !== activeShape.id) {
          let testShapeLines = shape.getLines();
          testShapeLines.forEach((testShapeLine) => {
            let pointFieldActiveShapeLineFrom = getPointField(activeShapeLine.from.x, activeShapeLine.from.y, activeShapeLine);
            let pointFieldActiveShapeLineTo = getPointField(activeShapeLine.to.x, activeShapeLine.to.y, activeShapeLine);
            let pointFieldTestShapeLineFrom = getPointField(testShapeLine.from.x, testShapeLine.from.y, testShapeLine);
            let pointFieldTestShapeLineTo = getPointField(testShapeLine.to.x, testShapeLine.to.y, testShapeLine);

            let intersectionCords = getIntersectCords(
              pointFieldActiveShapeLineFrom.x, pointFieldActiveShapeLineFrom.y,
              pointFieldActiveShapeLineTo.x, pointFieldActiveShapeLineTo.y,
              pointFieldTestShapeLineFrom.x, pointFieldTestShapeLineFrom.y,
              pointFieldTestShapeLineTo.x, pointFieldTestShapeLineTo.y,
              false
            );

            if (intersectionCords) {
              // ctx.beginPath();
              // ctx.arc(intersectionCords.x, intersectionCords.y, 10, 0, 2 * Math.PI);
              // ctx.stroke();
              //debugger // eslint-disable-line no-debugger
              (intersectionPoints[shape.id] = intersectionPoints[shape.id] || []).push(intersectionCords);
            }
          });
        }
      });
    });

    return intersectionPoints;
  }

  /**
   * @param {sqftShape} shape1
   * @param {sqftShape} shape2
   * @return {object} {sqftShape.id: [intersectionPoints]}
   */
  static getTwoShapesIntersections(shape1, shape2 ) {
    let activeShapeLines = shape1.getLines();
    let intersectionPoints = {};
    let testShapeLines = shape2.getLines();
    activeShapeLines.forEach((activeShapeLine) => {
      testShapeLines.forEach((testShapeLine) => {
        let pointFieldActiveShapeLineFrom = getPointField(activeShapeLine.from.x, activeShapeLine.from.y, activeShapeLine);
        let pointFieldActiveShapeLineTo = getPointField(activeShapeLine.to.x, activeShapeLine.to.y, activeShapeLine);
        let pointFieldTestShapeLineFrom = getPointField(testShapeLine.from.x, testShapeLine.from.y, testShapeLine);
        let pointFieldTestShapeLineTo = getPointField(testShapeLine.to.x, testShapeLine.to.y, testShapeLine);

        let intersectionCords = getIntersectionCordsV2(
          pointFieldActiveShapeLineFrom.x, pointFieldActiveShapeLineFrom.y,
          pointFieldActiveShapeLineTo.x, pointFieldActiveShapeLineTo.y,
          pointFieldTestShapeLineFrom.x, pointFieldTestShapeLineFrom.y,
          pointFieldTestShapeLineTo.x, pointFieldTestShapeLineTo.y,
          false
        );

        if (intersectionCords) {
          // const ctx = sqftEventManager.getCtx();
          // ctx.beginPath();
          // ctx.arc(intersectionCords.x, intersectionCords.y, 10, 0, 2 * Math.PI);
          // ctx.stroke();
          //debugger // eslint-disable-line no-debugger
          (intersectionPoints[shape2.id] = intersectionPoints[shape2.id] || []).push(intersectionCords);
        }
      });
    });

    return intersectionPoints;
  }

  static checkIfShapeContainsAnother(shape1, shape2) {
    let shape1Pos = shape1.getCenter();
    let shape1PosField = getPointField(shape1Pos.x, shape1Pos.y, shape1);
    // here will will check only shape center point
    for (let vertex of [shape1PosField]) {
      if (isPointInsideShape(vertex, shape2)) {
        return true;
      }
    }
    return false;
  }

  /**
   * @param {sqftShape} activeShape
   * @return {object} {sqftShape.id: {lineDirection: [{point: point, distance: int}]}}
   */
  static getDistancesToShapes(activeShape) {
    let activeShapeLines = activeShape.getLines();
    let shapes = workspace.getShapes();
    let distances = {};
    activeShapeLines.forEach((activeShapeLine) => {
      let pointFieldActiveShapeLineFrom = getPointField(activeShapeLine.from.x, activeShapeLine.from.y, activeShapeLine);

      shapes.forEach(function(shape) {
        if (shape instanceof sqftShape && !shape.isHidden && shape.id !== activeShape.id) {
          let testShapeLines = shape.getLines();
          testShapeLines.forEach((testShapeLine) => {
            let pointFieldTestShapeLineFrom = getPointField(testShapeLine.from.x, testShapeLine.from.y, testShapeLine);
            let pointFieldTestShapeLineTo = getPointField(testShapeLine.to.x, testShapeLine.to.y, testShapeLine);

            let distance = getDistanceFromPointToLine(
              pointFieldActiveShapeLineFrom.x, pointFieldActiveShapeLineFrom.y,
              pointFieldTestShapeLineFrom.x, pointFieldTestShapeLineFrom.y,
              pointFieldTestShapeLineTo.x, pointFieldTestShapeLineTo.y
            );

            if (distance || distance === 0) {
              let lineDirection = shape.getAngleDirection(testShapeLine);
              let diff = Math.abs(distance);

              if (diff < sqftConfig.SNAP_OFFSET) {
                let lineMidPoint = getMidPoint(pointFieldTestShapeLineFrom, pointFieldTestShapeLineTo);
                let result = {
                  shape: shape,
                  line: activeShapeLine,
                  point: pointFieldActiveShapeLineFrom,
                  distance,
                  diff,
                  diffX: pointFieldActiveShapeLineFrom.x - lineMidPoint.x,
                  diffY: pointFieldActiveShapeLineFrom.y - lineMidPoint.y,
                }
                distances[shape.id] = distances[shape.id] || {};
                (distances[shape.id][lineDirection.orientation] = distances[shape.id][lineDirection.orientation] || []).push(result);
              }
            }
          });
        }
      });
    });

    return distances;
  }

  /**
   * @param {sqftShape} activeShape
   * @return {object} {sqftShape.id: {lineDirection: [{point: point, distance: int}]}}
   */
  static getDistancesToWalls(activeShape) {
    let activeShapeLines = activeShape.getLines();
    let walls = workspaceControllers.walls.getResources();
    let distances = {};
    activeShapeLines.forEach((activeShapeLine) => {
      let pointFieldActiveShapeLineFrom = getPointField(activeShapeLine.from.x, activeShapeLine.from.y, activeShapeLine);

      walls.forEach(function(wall) {
        if (wall instanceof Wall) {
          //todo
          let testShapeLines = wall.getBordersOfWallLines();
          //let testShapeLines = wall.getLines();
          //console.log("testShapeLines", testShapeLines);
          activeShape.testShapeLines = testShapeLines;

          testShapeLines.forEach((testShapeLine) => {
            let pointFieldTestShapeLineFrom = testShapeLine.from.getPointField();
            let pointFieldTestShapeLineTo = testShapeLine.to.getPointField();

            let distance = getDistanceFromPointToLine(
              pointFieldActiveShapeLineFrom.x, pointFieldActiveShapeLineFrom.y,
              pointFieldTestShapeLineFrom.x, pointFieldTestShapeLineFrom.y,
              pointFieldTestShapeLineTo.x, pointFieldTestShapeLineTo.y
            );

            if (distance) {
              const lineOrientation = ShapeHelper.getLineOrientation(testShapeLine.from, testShapeLine.to, true);
              //console.log("lineOrientation",lineOrientation);
              let diff = Math.abs(distance);

              if (diff < sqftConfig.SNAP_OFFSET) {
                let lineMidPoint = getMidPoint(pointFieldTestShapeLineFrom, pointFieldTestShapeLineTo);
                let result = {
                  shape: wall,
                  line: activeShapeLine,
                  point: pointFieldActiveShapeLineFrom,
                  distance,
                  diff,
                  diffX: pointFieldActiveShapeLineFrom.x - lineMidPoint.x,
                  diffY: pointFieldActiveShapeLineFrom.y - lineMidPoint.y,
                }
                distances[wall.id] = distances[wall.id] || {};
                (distances[wall.id][lineOrientation] = distances[wall.id][lineOrientation] || []).push(result);
                //console.log("diff", diff);
              }
            }
          });
        }
      });
    });

    return distances;
  }

  /**
   * @param {object} pointFieldActivePoint {x, y}
   * @return {object} {sqftShape.id: {lineDirection: [{point: point, distance: int}]}}
   */
  static getDistancesToPoint(pointFieldActivePoint) {
    let shapes = workspace.getShapes();
    let distances = {};
    //let pointFieldActivePoint = getPointField(activePoint.x, activePoint.y);
    shapes.forEach(function(shape) {
      if (shape instanceof sqftShape && !shape.isHidden) {
        let testShapeLines = shape.getLines();
        testShapeLines.forEach((testShapeLine) => {
          let pointFieldTestShapeLineFrom = getPointField(testShapeLine.from.x, testShapeLine.from.y, testShapeLine);
          let pointFieldTestShapeLineTo = getPointField(testShapeLine.to.x, testShapeLine.to.y, testShapeLine);

          let distance = getDistanceFromPointToInfiniteLine(
            pointFieldActivePoint.x, pointFieldActivePoint.y,
            pointFieldTestShapeLineFrom.x, pointFieldTestShapeLineFrom.y,
            pointFieldTestShapeLineTo.x, pointFieldTestShapeLineTo.y
          );

          if (distance) {
            let lineDirection = shape.getAngleDirection(testShapeLine);
            let diff = distance;
            switch (lineDirection.orientation) {
              case 'vertical':
                diff = pointFieldActivePoint.x > pointFieldTestShapeLineFrom.x ? distance : -distance
                break;
              case 'horizontal':
                diff = pointFieldActivePoint.y > pointFieldTestShapeLineFrom.y ? distance : -distance
                break;
              //todo rotated - set diff distance from tested point to line(beam)
              default:
                break;
            }

            if (distance < sqftConfig.SNAP_OFFSET) {
              let result = {
                shape: shape,
                line: testShapeLine,
                point: pointFieldActivePoint,
                distance,
                diff,
              }
              distances[shape.id] = distances[shape.id] || {};
              (distances[shape.id][lineDirection.orientation] = distances[shape.id][lineDirection.orientation] || []).push(result);
            }
          }
        });
      }
    });

    return distances;
  }

  /**
   * @param {sqftShape} activeShape
   * @return {object} {sqftShape.id: {lineDirection: [{point: point, distance: int}]}}
   */
  static getDistancesToSlabImages(activeShape) {
    let activeShapeLines = activeShape.getLines();
    let croppedSlabImages = store.getState().sqftSlabState.croppedSlabImages;
    let distances = {};
    activeShapeLines.forEach((activeShapeLine) => {
      let pointFieldActiveShapeLineFrom = getPointField(activeShapeLine.from.x, activeShapeLine.from.y, activeShapeLine);

      croppedSlabImages.forEach(function(movableImage) {
        if (!movableImage.isHidden) {
          let testImagePoints = movableImage.getLinePointsPointField();
          for (let i = 0; i <= testImagePoints.length - 1; i++) {
            let from = testImagePoints[i];
            let to = testImagePoints[i === testImagePoints.length - 1 ? 0 : i + 1] ;
            let distance = getDistanceFromPointToLine(
              pointFieldActiveShapeLineFrom.x, pointFieldActiveShapeLineFrom.y,
              from.x, from.y,
              to.x, to.y,
            );
            const lineOrientation = ShapeHelper.getLineOrientation(from, to);
            let diff = Math.abs(distance);

            if (diff < sqftConfig.SNAP_OFFSET) {
              let lineMidPoint = getMidPoint(from, to);
              let result = {
                shape: movableImage,
                line: activeShapeLine,
                point: pointFieldActiveShapeLineFrom,
                distance,
                diff,
                diffX: pointFieldActiveShapeLineFrom.x - lineMidPoint.x,
                diffY: pointFieldActiveShapeLineFrom.y - lineMidPoint.y,
              }
              distances[movableImage.id] = distances[movableImage.id] || {};
              (distances[movableImage.id][lineOrientation] = distances[movableImage.id][lineOrientation] || []).push(result);
            }
          }
        }
      });
    });

    return distances;
  }

  /**
   * @param {sqftShape} activeShape
   * @return {object} {sqftShape.id: {lineDirection: [{point: point, distance: int}]}}
   */
  static getDistancesToImages(activeShape) {
    let activeShapeLines = activeShape.getLines();
    let appliances = sqftImageManager.getAppliances();
    let slabImages = sqftImageManager.getSlabImages();
    const images = slabImages.concat(appliances);
    let distances = {};
    activeShapeLines.forEach((activeShapeLine) => {
      let pointFieldActiveShapeLineFrom = getPointField(activeShapeLine.from.x, activeShapeLine.from.y, activeShapeLine);

      images.forEach(function(movableImage) {
        if (!movableImage.isHidden && movableImage.id !== activeShape.id) {
          let testImagePoints = movableImage.getLinePointsPointField();
          for (let i = 0; i <= testImagePoints.length - 1; i++) {
            let from = testImagePoints[i];
            let to = testImagePoints[i === testImagePoints.length - 1 ? 0 : i + 1] ;
            let distance = getDistanceFromPointToLine(
              pointFieldActiveShapeLineFrom.x, pointFieldActiveShapeLineFrom.y,
              from.x, from.y,
              to.x, to.y,
            );
            const lineOrientation = ShapeHelper.getLineOrientation(from, to);
            let diff = Math.abs(distance);

            if (diff < sqftConfig.SNAP_OFFSET) {
              let lineMidPoint = getMidPoint(from, to);
              let result = {
                shape: movableImage,
                line: activeShapeLine,
                point: pointFieldActiveShapeLineFrom,
                distance,
                diff,
                diffX: pointFieldActiveShapeLineFrom.x - lineMidPoint.x,
                diffY: pointFieldActiveShapeLineFrom.y - lineMidPoint.y,
              }
              distances[movableImage.id] = distances[movableImage.id] || {};
              (distances[movableImage.id][lineOrientation] = distances[movableImage.id][lineOrientation] || []).push(result);
            }
          }
        }
      });
    });

    return distances;
  }

  static getLineOrientation(point1, point2, usePointsV2 = false) {
    const x1 = usePointsV2 ? point1.modelCorePoint.getPosX() : point1.x
    const x2 = usePointsV2 ? point2.modelCorePoint.getPosX() : point2.x
    const y1 = usePointsV2 ? point1.modelCorePoint.getPosY() : point1.y
    const y2 = usePointsV2 ? point2.modelCorePoint.getPosY() : point2.y
    let slope = (y1 - y2) / (x1 - x2);
    let xDiff = Math.round(Math.abs(x2 - x1));
    let yDiff = Math.round(Math.abs(y2 - y1));
    if (xDiff === 0) {
      return "vertical";
    } else if (yDiff === 0) {
      return "horizontal";
    } else {
      if (slope >= 0) { //southeast and northwest
        if (x2 > x1) {
          return "SOUTHEAST";
        } else {
          return "NORTHWEST";
        }
      } else {
        if (x2 > x1) {
          return "NORTHEAST";
        } else {
          return "SOUTHWEST";
        }
      }
    }
  }

  /**
   * find all snapping possibilities
   * @param {object} itemBounds
   * @return {object} {sqftShape.id: [intersectionPoints]}
   */
  static getSnappingPossibilities(itemBounds) {
    if (Object.keys(itemBounds).length === 0) {
      return []
    }
    let resultV = [], resultH = [];
    for (let i in itemBounds) {
      if (itemBounds[i].vertical) {
        itemBounds[i].vertical.forEach((itemBound) => {
          resultV.push({
            shape: itemBound.shape,
            line: itemBound.line,
            point: itemBound.point,
            offset: itemBound.distance,
            diff: itemBound.diffX,
            orientation: "vertical",
          });
        });
      }
      if (itemBounds[i].horizontal) {
        itemBounds[i].horizontal.forEach((itemBound) => {
          resultH.push({
            shape: itemBound.shape,
            line: itemBound.line,
            point: itemBound.point,
            offset: itemBound.distance,
            diff: itemBound.diffY,
            orientation: "horizontal",
          });
        });
      }
    }

    let guides = [];

    // find closest snap
    let minV = resultV.sort((a, b) => a.diff - b.diff)[0];
    let minH = resultH.sort((a, b) => a.diff - b.diff)[0];
    if (minV) {
      guides.push(minV);
    }
    if (minH) {
      guides.push(minH);
    }
    if (guides.length > 0) {
      //debugger // eslint-disable-line no-debugger
    }
    return guides;
  }

  /**
   * Find all snapping possibilities for the same part ID
   * @param {object} itemBounds
   * @param partId
   * @return {object} {sqftShape.id: [intersectionPoints]}
   */
  static getItemBoundsForTheSamePartIdIfExist(itemBounds, partId) {
    if (Object.keys(itemBounds).length === 0) {
      return {};
    }

    const newItemBounds = {};

    for (let key in itemBounds) {
      if (itemBounds.hasOwnProperty(key)) {
        let verticalElements = [];
        let horizontalElements = [];

        if (itemBounds[key].vertical) {
          verticalElements = itemBounds[key].vertical.filter(verticalElement => verticalElement.shape.partId === partId);
        }

        if (itemBounds[key].horizontal) {
          horizontalElements = itemBounds[key].horizontal.filter(horizontalElement => horizontalElement.shape.partId === partId);
        }

        if (verticalElements.length > 0 || horizontalElements.length > 0) {
          newItemBounds[key] = {
            vertical: verticalElements.length > 0 ? verticalElements : undefined,
            horizontal: horizontalElements.length > 0 ? horizontalElements : undefined
          };
        }
      }
    }

    return newItemBounds;
  }

  /**
   * find all snapping possibilities
   * @param {object} itemBounds
   * @return {object} {sqftShape.id: [intersectionPoints]}
   */
  static getSnappingPossibilitiesToLines(itemBounds) {
    if (Object.keys(itemBounds).length === 0) {
      return []
    }
    let resultV = [], resultH = [];
    for (let i in itemBounds) {
      if (itemBounds[i].vertical) {
        itemBounds[i].vertical.forEach((itemBound) => {
          resultV.push({
            line: itemBound.line,
            point: itemBound.point,
            distance: itemBound.distance,
            diff: itemBound.diff,
            orientation: "vertical",
          });
        });
      }
      if (itemBounds[i].horizontal) {
        itemBounds[i].horizontal.forEach((itemBound) => {
          resultH.push({
            line: itemBound.line,
            point: itemBound.point,
            diff: itemBound.diff,
            orientation: "horizontal",
          });
        });
      }
    }

    let guides = [];

    // find closest snap
    let minV = resultV.sort((a, b) => a.distance - b.distance)[0];
    let minH = resultH.sort((a, b) => a.distance - b.distance)[0];
    if (minV) {
      guides.push(minV);
    }
    if (minH) {
      guides.push(minH);
    }

    if (guides.length > 0) {
      //debugger // eslint-disable-line no-debugger
    }
    return guides;
  }

  static getMinLengthToPoints(shape, points) {
    let shapeLines = shape.getLines();
    let minLength = null;
    let pointDistances = [];
    points.forEach(function(point) {
      shapeLines.forEach(function(line) {
        let pointField = getPointField(line.from.x, line.from.y, line)
        let pointDistance = getPointDistance(pointField, point);

        pointDistances.push(pointDistance);
        if (minLength === null || pointDistance < minLength) {
          minLength = pointDistance
        }
      })
    })
    pointDistances.sort((a, b) => a - b);
    //console.log("pointDistances", pointDistances);

    return pointDistances ? pointDistances : null
  }

  static getInnerCornerPoints(shape) {
    let lines = shape.getLines(),
      points = [];

    for (let i = 0; i < lines.length; i++) {
      if (lines[i].to.angle > 0 || lines[i].to.arcLength > 0) {
        let dir = shape.getAngleDirection(lines[i]);
        if (this.isAngleInner(dir)) {
          points.push(lines[i].to);
        }
      }
    }

    return points
  }

  static isAngleInner(dir) {
    let isInner = false;
    switch(dir.facing) {
      case "nw":
        if (dir.orientation === "horizontal") {
          isInner = true
        }
        break;
      case "ne":
        if (dir.orientation === "vertical") {
          isInner = true
        }
        break;
      case "se":
        if (dir.orientation === "horizontal") {
          isInner = true
        }
        break;
      case "sw":
        if (dir.orientation === "vertical") {
          isInner = true
        }

        break;
    }

    return isInner;
  }

  //deprecated (old rotation function) use getCenterPoint
  static getShapeCenter(lines, isSlabMode) {
    let max_x = 0, min_x = 0, max_y = 0, min_y = 0;
    for(let i = 0; i < lines.length; i++) {
      let rotatePointX = isSlabMode ? lines[i].from.posSlab.x : lines[i].from.x;
      let rotatePointY = isSlabMode ? lines[i].from.posSlab.y : lines[i].from.y;
      if (max_x < rotatePointX)
        max_x = rotatePointX;
      if (min_x > rotatePointX)
        min_x = rotatePointX;
      if (max_y < rotatePointY)
        max_y = rotatePointY;
      if (min_y > rotatePointY)
        min_y = rotatePointY;
    }

    return {x: ((max_x - min_x) / 2) + min_x, y: ((max_y - min_y) / 2) + min_y};
  }

  static getCenterPoint(points) {
    let xCords = points.map (point => point.x);
    let yCords = points.map (point => point.y);
    let cx = (Math.min (...xCords) + Math.max (...xCords)) / 2;
    let cy = (Math.min (...yCords) + Math.max (...yCords)) / 2;

    return {x: cx, y: cy};
  }

  static getAbsolutePosFromSnapPossibilities = (snapPossibilities, pos) => {
    if (snapPossibilities.length > 0) {
      let scale = sqftConfig.scale;
      let absolutePos = {...pos};
      let snapWithShape = null;
      snapPossibilities.forEach((snap) => {
        switch (snap.orientation) {
          case "horizontal":
            absolutePos.y -= snap.diff / scale
            break;
          case "vertical":
            absolutePos.x -= snap.diff / scale
            break;
        }
        snapWithShape = snap.shape;
      })
      return [absolutePos, snapWithShape]
    }
    return [null, null]
  }
}

/**
 * get line length number text from 2 point
 */
export const getLineLengthNumberText = (pointFrom, pointTo, parent, changeValueCallback) => {
  const midPoint = getMidPoint(pointFrom.getPosition(), pointTo.getPosition()),
    lineOrientation = getLineOrientation(pointFrom, pointTo),
    //todo line direction
    lineDirection = {newDirection: "west"},//getPointDirection(pointFrom, pointTo, nextPoint, prevPoint),
    distance = getPointDistance(pointFrom, pointTo);

  let yOffset = 0,
    xOffset = 0;

  switch (lineOrientation) {
    case orientation.HORIZONTAL: {
      yOffset = lineDirection.newDirection === "west" ? 36 + 10 : -36;
      break;
    }
    case orientation.VERTICAL: {
      xOffset = (lineDirection.newDirection === "south" ? 36 + 10 : -36 - 10);
      break;
    }
    //TODO rotation
    case orientation.NORTHWEST: { break; }
    case orientation.NORTHEAST: { break; }
    case orientation.SOUTHWEST: { break; }
    case orientation.SOUTHEAST: { break; }
    default: break;
  }

  let pos = {
    x: midPoint.x,
    y: midPoint.y,
    xOffset: xOffset,
    yOffset: yOffset,
    orientation: lineOrientation,
    betweenPoints: {
      pointFrom: pointFrom,
      pointTo: pointTo,
    }
  };

  let design = {
    shouldRenderFrameBorder: true,
    isLength: true
  };

  return new NumberText(distance, pos, design, parent, changeValueCallback);
}

export const getPointDirection = (aP, bP, cP, lineBeforeFrom) => {  // line1.from , line1.to, line2.to, lineBefore.from
  var
    mAC = getMidPoint(aP, cP),
    vDir,
    hDir,
    orientation = ShapeHelper.getLineOrientation(aP,bP),
    newDirection = '',
    cornerMargins = {
      fromTop : 0,
      fromLeft : 0,
      fromRight : 0,
      fromBottom : 0,
    },
    dirX = 'forward',
    dirY = 'forward';

  if (aP.x > bP.x) {
    dirX = 'backward';
  }
  if (aP.y < bP.y) {
    dirY = 'backward';
  }
  if (bP.y >= mAC.y) {
    vDir = "n";
  } else {
    vDir = "s";
  }
  if (bP.x >= mAC.x) { // 155 - 118
    hDir = "w";
  } else {
    hDir = "e";
  }

  var point1X = aP.x - (aP.x % 1),
    point1Y = aP.y - (aP.y % 1),
    point2X = bP.x - (bP.x % 1),
    point2Y = bP.y - (bP.y % 1),
    point3X = cP.x - (cP.x % 1),
    point3Y = cP.y - (cP.y % 1),
    pointBeforeX = lineBeforeFrom.x - (lineBeforeFrom.x % 1),
    pointBeforeY = lineBeforeFrom.y - (lineBeforeFrom.y % 1); // remove all after dot for proper compare

  if (orientation === "horizontal") {
    newDirection = (point1X > point2X) ? "west" : "east"
  }

  if (orientation === "vertical") {
    newDirection = (point1Y > point2Y) ? "north" : "south"
  }

  if ((point1X === point2X) && (point2Y === point3Y) && (point1X < pointBeforeX) && (newDirection === "south")
    || (point1X === point2X) && (point2Y === point3Y) && (point2X > cP.x) && (newDirection === "north")) {
    cornerMargins.fromTop = true
  }
  if ((point1Y === point2Y) && (point2X === point3X) && (point3Y > point2Y) && (point1X > point2X)
    ||(point1Y === point2Y) && (pointBeforeX === point1X) && (pointBeforeY < point1Y) && (point2X > point1X)) {
    cornerMargins.fromLeft = true
  }
  if ((point1Y === point2Y) && (point1X === pointBeforeX) && (pointBeforeY > point1Y) && (point1X > point2X)
    ||(point1Y === point2Y) && (point2X === point3X) && (point2Y > point3Y) && (point2X > point1X)) {
    cornerMargins.fromRight = true
  }
  if ((point1X === point2X) && (point2Y === point3Y) && (point1Y < point2Y) && (point3X > point2X)
    ||(point1X === point2X) && (point1Y === pointBeforeY) && (point1X > pointBeforeX) && (point1Y > point2Y)) {
    cornerMargins.fromBottom = true
  }

  return {
    facing: vDir + hDir,
    direction: {x: dirX, y: dirY},
    cornerMargins : cornerMargins,
    orientation : orientation,
    newDirection : newDirection
  }

}

/**
 * get line length number text from 2 point
 */
export const getLineLengthNumberTextV2 = (pointFrom, pointTo, parent, changeValueCallback) => {
  const midPoint = getMidPoint(pointFrom.getPosition(), pointTo.getPosition()),
    lineOrientation = getLineOrientation(pointFrom, pointTo),
    lineDirection = getLineDirection(pointFrom, pointTo),
    distance = getPointDistance(pointFrom, pointTo);

  let yOffset = 0,
    xOffset = 0;

  switch (lineOrientation) {
    case orientation.HORIZONTAL: {
      const ctx = sqftEventManager.getCtx();
      const fontSize = getFontSizeFromContext(ctx);
      yOffset = lineDirection === DIRECTIONS.WEST ? fontSize : -fontSize;

      break;
    }
    case orientation.VERTICAL: {
      xOffset = (lineDirection === DIRECTIONS.SOUTH ? + 10 : - 10);
      break;
    }
    //TODO rotation
    case orientation.NORTHWEST: { break; }
    case orientation.NORTHEAST: { break; }
    case orientation.SOUTHWEST: { break; }
    case orientation.SOUTHEAST: { break; }
    default: break;
  }

  let pos = {
    x: midPoint.x,
    y: midPoint.y,
    xOffset: xOffset,
    yOffset: yOffset,
    orientation: lineOrientation,
    betweenPoints: {
      pointFrom: pointFrom,
      pointTo: pointTo,
    }
  };

  let design = {
    shouldRenderFrameBorder: false,
    isLength: true,
    priority: EventManager.priorities.SEGMENT
  };

  return new NumberText(distance, pos, design, parent, changeValueCallback);
}

/**
 * get line length number text from 2 point
 */
export const getLineLengthNumberTextV2ForTheImage = (pointFrom, pointTo, parent, changeValueCallback, shouldOnlyRenderText = false) => {
  const midPoint = getMidPoint(pointFrom.getPosition(), pointTo.getPosition()),
    lineOrientation = getLineOrientation(pointFrom, pointTo),
    lineDirection = getLineDirection(pointFrom, pointTo),
    distance = getPointDistance(pointFrom, pointTo);

  let yOffset = 0,
    xOffset = 0;
  const ctx = sqftEventManager.getCtx();
  const fontSize = getFontSizeFromContext(ctx);
  const padding = 0; //todo padding also should be on hover
  switch (lineOrientation) {
    case orientation.HORIZONTAL: {
      yOffset = lineDirection === DIRECTIONS.WEST ? fontSize - padding : fontSize - padding;
      break;
    }
    case orientation.VERTICAL: {
      xOffset = (lineDirection === DIRECTIONS.SOUTH ? - 0 :  0);
      yOffset = lineDirection === DIRECTIONS.WEST ? fontSize - padding : fontSize - padding;
      break;
    }
    //TODO rotation
    case orientation.NORTHWEST: { break; }
    case orientation.NORTHEAST: { break; }
    case orientation.SOUTHWEST: { break; }
    case orientation.SOUTHEAST: { break; }
    default: break;
  }

  let pos = {
    x: midPoint.x,
    y: midPoint.y,
    xOffset: xOffset,
    yOffset: yOffset,
    orientation: lineOrientation,
    betweenPoints: {
      pointFrom: pointFrom,
      pointTo: pointTo,
    }
  };

  let design = {
    shouldOnlyRenderText: shouldOnlyRenderText,
    shouldRenderFrameBorder: false,
    isLength: true,
    eventsPriority: EventManager.priorities.IMAGE_LINE
  };

  return new NumberText(distance, pos, design, parent, changeValueCallback);
}

export const getLineDirection = (pointA, pointB, shouldRound = false) => {
  let deltaX, deltaY;
  if (shouldRound) {
    deltaX = Math.round10(pointB.x, -1) - Math.round10(pointA.x, -1);
    deltaY = Math.round10(pointB.y, -1) - Math.round10(pointA.y, -1);
  } else {
    deltaX = pointB.x - pointA.x;
    deltaY = pointB.y - pointA.y;
  }

  if (deltaX > 0 && deltaY === 0) {
    return DIRECTIONS.EAST;
  } else if (deltaX < 0 && deltaY === 0) {
    return DIRECTIONS.WEST;
  } else if (deltaY > 0 && deltaX === 0) {
    return DIRECTIONS.SOUTH;
  } else if (deltaY < 0 && deltaX === 0) {
    return DIRECTIONS.NORTH;
  } else if (deltaX > 0 && deltaY < 0) {
    return DIRECTIONS.NORTHEAST;
  } else if (deltaX < 0 && deltaY < 0) {
    return DIRECTIONS.NORTHWEST;
  } else if (deltaX > 0 && deltaY > 0) {
    return DIRECTIONS.SOUTHEAST;
  } else if (deltaX < 0 && deltaY > 0) {
    return DIRECTIONS.SOUTHWEST;
  } else {
    return DIRECTIONS.UNDEFINED;
  }
}

/**
 * @Deprecated. Use getLineDirection instead
 */
export const getLineOrientation = (pointFrom, pointTo) => {
  let slope = getSlope(pointFrom, pointTo),
   xDiff = Math.round(Math.abs(pointTo.x - pointFrom.x)),
   yDiff = Math.round(Math.abs(pointTo.y - pointFrom.y));

  if (xDiff === 0) {
    return orientation.VERTICAL;
  } else if (yDiff === 0) {
    return orientation.HORIZONTAL;
  } else {
    if (slope >= 0) { //southeast and northwest
      if (pointTo.x > pointFrom.x) {
        return orientation.SOUTHEAST;
      } else {
        return orientation.NORTHWEST;
      }
    } else {
      if (pointTo.x > pointFrom.x) {
        return orientation.NORTHEAST;
      } else {
        return orientation.SOUTHWEST;
      }
    }
  }
}

export const getSlope = (pointFrom, pointTo) => {
  let x1 = pointFrom.x,
    x2 = pointTo.x,
    y1 = pointFrom.y,
    y2 = pointTo.y;

  return (y1 - y2) / (x1 - x2);
}

export const getSlopeV2 = (pointFrom, pointTo) => {
  if (pointTo.x - pointFrom.x !== 0) {
    return (pointTo.y - pointFrom.y) / (pointTo.x - pointFrom.x);
  }
  return Number.MAX_VALUE;
}

/**
 * @param {{from: {x:number, y: number}, to: {x:number, y: number}}} line1
 * @param {{from: {x:number, y: number}, to: {x:number, y: number}}} line2
 * get angle between two lines https://www.geeksforgeeks.org/angle-between-a-pair-of-lines/
 */
export const getAngleBetweenTwoLines = (line1, line2) => {
  const slopeLine1 = getSlopeV2(line1.from, line1.to);
  const slopeLine2 = getSlopeV2(line2.from, line2.to);

  return getAngleBetweenTwoSlopes(slopeLine1, slopeLine2);
}

export const getAngleBetweenTwoSlopes = (M1, M2) => {
  // Store the tan value of the angle
  let angle = Math.abs((M2 - M1) / (1 + M1 * M2));

  // Calculate tan inverse of the angle
  let ret = Math.atan(angle);

  // Convert the angle from
  // radian to degree

  return (ret * 180) / Math.PI;
}

/**
 * @param {{x:number, y: number}} point1
 * @param {{x:number, y: number}} point2
 */
export const getVectorByPoints = (point1, point2) => {
  return {x: point2.x - point1.x, y: point2.y - point1.y}
}

/**
 * @param {{from: {x:number, y: number}, to: {x:number, y: number}}} line1
 * @param {{from: {x:number, y: number}, to: {x:number, y: number}}} line2
 */
export const getAngleBetweenTwoLinesV2 = (line1, line2) => {
  const vector1 = getVectorByPoints(line1.to, line1.from);
  const vector2 = getVectorByPoints(line2.from, line2.to);
  //const pointDistance = Math.sqrt(Math.pow(vectorLine2.x - vectorLine1.x, 2) + Math.pow(vectorLine2.y - vectorLine1.y, 2));
  const cosAngle = (vector1.x + vector2.x + vector1.y + vector2.y)
    / Math.sqrt(Math.pow(vector1.x, 2) + Math.pow(vector1.y, 2))
    * Math.sqrt(Math.pow(vector2.x, 2) + Math.pow(vector2.y, 2));

  //todo
  //console.log("cosAngle", cosAngle);
  return Math.acos (cosAngle)
}

/**
 * Calculates the angle ABC ()
 *
 * A first point, ex: {x: 0, y: 0}
 * C second point
 * B center point
 **/
export const getAngleBetween3Points = (A, B, C) => {
  let AB = Math.sqrt(Math.pow(B.x - A.x,2)+ Math.pow(B.y - A.y,2));
  let BC = Math.sqrt(Math.pow(B.x - C.x,2)+ Math.pow(B.y - C.y,2));
  let AC = Math.sqrt(Math.pow(C.x - A.x,2)+ Math.pow(C.y - A.y,2));
  const angleInRadians = Math.acos((BC*BC+AB*AB-AC*AC)/(2*BC*AB));

  return (angleInRadians * 180) / Math.PI
}

export const getFeatureGroupByPartIds = (partIds) => {
  const layout = getCurrentLayout();
  for (const partId of partIds) {
    const featureGroup = layout.getFeatureGroupByPartId(partId);
    if (featureGroup) {
      return featureGroup
    }
  }

  return null
}

export const getEdgeFeatureGroup = () => {
  if (!SqftStore.edgeFeatureGroups) {
    SqftStore.edgeFeatureGroups = {};
  }

  const visualizerType = document.kvConfig.visualizerType;

  // Check if the edgeFeatureGroup for the current visualizerType is already cached
  if (!SqftStore.edgeFeatureGroups[visualizerType]) {
    const mainNeeded = "edge_profile";
    const oppositeNeeded = "center_island_edge";
    const layout = getCurrentLayout(visualizerType);

    let featureGroup = layout.getSubPartFromQtCategories(mainNeeded);
    if (!featureGroup) {
      featureGroup = layout.getSubPartFromQtCategories(oppositeNeeded);
    }
    if (!featureGroup) {
      featureGroup = layout.parts["Countertop"] && layout.parts["Countertop"].edge
        ? { part: layout.parts["Countertop"].edge }
        : null;
    }
    if (!featureGroup) {
      let fg = layout.getFeatureGroupByPartId("edge_profile");
      if (fg) {
        featureGroup = {part: fg};
      }
    }

    // Cache the result for the current visualizerType
    SqftStore.edgeFeatureGroups[visualizerType] = featureGroup;
  }

  return SqftStore.edgeFeatureGroups[visualizerType];
};

export const getEdgeFeatures = (edgeFeatureGroup) => {
  if (!edgeFeatureGroup) {
    edgeFeatureGroup = getEdgeFeatureGroup();
  }
  if (!edgeFeatureGroup) {
    return []
  }
  const state = store.getState();
  const {wizardIsActive} = state.wizardState;

  if (SqftStore.edgeFeatures.length === 0) {
    let navItems

    if (wizardIsActive) {
      navItems = getNavItemsFromTheWizard(edgeFeatureGroup);
    } else {
      const layout = getCurrentLayout();
      navItems = layout.designNavigationItems(edgeFeatureGroup,
      {},
      "",
      false,
      "all",
      [],
      { firstFeature: null, firstConditions: null },
      )
    }

    SqftStore.edgeFeatures = edgeFeatureGroup
      ? navItems
      : [];
  }

  return SqftStore.edgeFeatures
};

export const getBacksplashFeatureGroup = () => {
  if (!SqftStore.backsplashFeatureGroups) {
    SqftStore.backsplashFeatureGroups = {};
  }
  const visualizerType = document.kvConfig.visualizerType;
  if (!SqftStore.backsplashFeatureGroups[visualizerType]) {
    const layout = getCurrentLayout(visualizerType);
    for (const backsplashPartId of Object.keys(BACKSPLASH_LABELS)) {
      const featureGroup = layout.getFeatureGroupByPartId(backsplashPartId);
      if (featureGroup) {
        SqftStore.backsplashFeatureGroups[visualizerType] = featureGroup;
      }
    }
  }

  return SqftStore.backsplashFeatureGroups[visualizerType];
}


/**
 * countertopPartName will be center_island_countertop if it not exists in the room or at all in qtCategories the same
 * for center_island_countertop, it will return countertop if center_island_countertop not exists
 * @returns {[string, string]} countertopPartName, centerIslandPartName
 */
export const getCountertopPartNames = (intl = null) => {
  const state = store.getState();
  const {quotes, activeQuoteIndex} = state.quotesState;
  const fabricatorData = state.fabricatorState;
  const activeRoomId = state.sqftMenuState.activeRoomId;
  const cartItems = state.cartState.cartItems;
  intl = intl ? intl : workspace.intl;
  const roomName = getRoomName(activeQuoteIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData);
  void roomName; //todo remove
  const room = activeRoomId ? activeRoomId : document.kvConfig.visualizerType
  const layout = getCurrentLayout();

  let countertopNavItem = layout.getSubPartFromQtCategories(SHAPE_PART_ID.countertop, room);
  let centerIslandNavItem = layout.getSubPartFromQtCategories(SHAPE_PART_ID.center_island_countertop, room);

  if (!countertopNavItem && !centerIslandNavItem) {
    countertopNavItem = layout.getSubPartFromQtCategories(SHAPE_PART_ID.countertop);
    centerIslandNavItem = layout.getSubPartFromQtCategories(SHAPE_PART_ID.center_island_countertop);
  }

  //try to assign vanity countertop if countertop or center_island_countertop not exist
  if (!countertopNavItem && !centerIslandNavItem) {
    countertopNavItem = centerIslandNavItem = layout.getSubPartFromQtCategories(SHAPE_PART_ID.vanity_countertop);
  }

  const countertopPartName = countertopNavItem ? countertopNavItem.part.partId : SHAPE_PART_ID.center_island_countertop;
  const centerIslandPartName = centerIslandNavItem ? centerIslandNavItem.part.partId : SHAPE_PART_ID.countertop;

  return [countertopPartName, centerIslandPartName];
}

/**
 * Test if shape part ids are equal, parentPartId is added for the spacers
 * @param shape
 * @param testShape
 * @return {boolean}
 */
export const canShapeBeAutoShifted = (shape, testShape) => {
  const isShapePlacedOnTheFloor = getIsShapePlacedOnTheFloor(shape);
  const isShapePlacedOnTheWall = getIsShapePlacedOnTheWall(shape);

  const isTestShapePlacedOnTheFloor = getIsShapePlacedOnTheFloor(testShape);
  const isTestShapePlacedOnTheWall = getIsShapePlacedOnTheWall(testShape);

  return (shape.id !== testShape.id &&
    (isShapePlacedOnTheWall && isTestShapePlacedOnTheWall)
    || (isShapePlacedOnTheFloor && isTestShapePlacedOnTheFloor)
    )
}

export const getIsShapePlacedOnTheFloor = (shape) => {
  return (shape.partId === SHAPE_PART_ID.tall_cabinet_boxes
  || shape.parentPartId === SHAPE_PART_ID.tall_cabinet_boxes
  || shape.partId === SHAPE_PART_ID.lower_cabinet_boxes
  || shape.parentPartId === SHAPE_PART_ID.lower_cabinet_boxes
  || shape.partId === SHAPE_PART_ID.vanitie_cabinet_boxes
  || shape.parentPartId === SHAPE_PART_ID.vanitie_cabinet_boxes
  || shape.partId === SHAPE_PART_ID.vanity_cabinet_boxes
  || shape.parentPartId === SHAPE_PART_ID.vanitie_cabinet_boxes
  || shape.subType === SHAPE_PART_ID.fridge
  || shape.subType === SHAPE_PART_ID.stove
  || shape.subType === SQFT_APPLIANCES.range
  || shape.subType === SQFT_APPLIANCES.sink
  || shape.subType === SQFT_APPLIANCES.doubleSink
  || shape.subType === SQFT_APPLIANCES.dishwasher
  || shape.subType === SQFT_APPLIANCES.iceMachine
  || shape.subType === SQFT_APPLIANCES.oven
  || shape.subType === SQFT_APPLIANCES.stovetop
  || shape.subType === SQFT_APPLIANCES.trashCompactor
  || shape.subType === SQFT_APPLIANCES.wineFridge
)}

export const getIsShapePlacedOnTheWall = (shape) => {
  return (shape.partId === SHAPE_PART_ID.upper_cabinet_boxes
  || shape.parentPartId === SHAPE_PART_ID.upper_cabinet_boxes
  || shape.subType === SQFT_APPLIANCES.hood
)}

function normVec(a, b) {
  const dx = b.x - a.x;
  const dy = b.y - a.y;
  const len = Math.hypot(dx, dy);
  return { x: dx / len, y: dy / len };
}

export function setShapeWidth(shape, newWidth) {
  const lines = shape.getLines();
  const pts = lines.map(l => l.from);
  const widthVec = normVec(lines[0].from, lines[0].to);

  const proj = pts.map(p => p.x * widthVec.x + p.y * widthVec.y);
  const minP = Math.min(...proj);
  const maxP = Math.max(...proj);
  const oldWidth = maxP - minP;
  const delta = (newWidth - oldWidth) / 2;

  pts.forEach((p, i) => {
    if (Math.abs(proj[i] - minP) < 1e-6) {
      p.x -= widthVec.x * delta;
      p.y -= widthVec.y * delta;
    }
    if (Math.abs(proj[i] - maxP) < 1e-6) {
      p.x += widthVec.x * delta;
      p.y += widthVec.y * delta;
    }
  });
}

export function setShapeDepth(shape, newDepth) {
  const lines = shape.getLines();
  const pts = lines.map(l => l.from);
  const widthVec = normVec(lines[0].from, lines[0].to);
  const depthVec = { x: -widthVec.y, y: widthVec.x };

  const proj = pts.map(p => p.x * depthVec.x + p.y * depthVec.y);
  const minP = Math.min(...proj);
  const maxP = Math.max(...proj);
  const oldDepth = maxP - minP;
  const delta = (newDepth - oldDepth) / 2;

  pts.forEach((p, i) => {
    if (Math.abs(proj[i] - minP) < 1e-6) {
      p.x -= depthVec.x * delta;
      p.y -= depthVec.y * delta;
    }
    if (Math.abs(proj[i] - maxP) < 1e-6) {
      p.x += depthVec.x * delta;
      p.y += depthVec.y * delta;
    }
  });
}

export function getShapeAxes(shape) {
  const lines = shape.getLines();
  const firstLine = lines[0];
  const dx = firstLine.to.x - firstLine.from.x;
  const dy = firstLine.to.y - firstLine.from.y;
  const angle = Math.atan2(dy, dx);
  return {
    widthAxis: angle,
    depthAxis: angle + Math.PI / 2
  };
}


export function setShapeWidthBySplit(shape, newWidth) {
  setShapeSizeBySplit(shape, newWidth, 'width');
}

export function setShapeDepthBySplit(shape, newDepth) {
  setShapeSizeBySplit(shape, newDepth, 'depth');
}

/**
 * Enhanced resize function for width that includes auto shift
 * @param {Object} shape - Shape to resize
 * @param {number} newWidth - New width
 */
export function setShapeWidthWithAutoShift(shape, newWidth) {
  const oldWidth = shape.getWidth();

  // Create auto shift manager
  const autoShift = new ShapeResizeAutoShift(shape);

  // Perform the resize
  setShapeWidthBySplit(shape, newWidth);

  // Handle auto shift of group shapes
  autoShift.handleWidthResizeAutoShift(oldWidth, newWidth);
}

/**
 * Enhanced resize function for depth that includes auto shift
 * @param {Object} shape - Shape to resize
 * @param {number} newDepth - New depth
 */
export function setShapeDepthWithAutoShift(shape, newDepth) {
  const oldDepth = shape.getDepth();

  // Create auto shift manager
  const autoShift = new ShapeResizeAutoShift(shape);

  // Perform the resize
  setShapeDepthBySplit(shape, newDepth);

  // Handle auto shift of group shapes
  autoShift.handleDepthResizeAutoShift(oldDepth, newDepth);
}

/**
 * Universal function for splitting shape by width or depth
 * @param {Object} shape - Shape to resize
 * @param {number} newSize - New size (width or depth)
 * @param {string} direction - 'width' or 'depth'
 */
export function setShapeSizeBySplit(shape, newSize, direction) {
  const lines = shape.getLines();
  const pts = lines.map(l => l.from);

  let resizeVec;

  if (direction === 'width') {
    // Use the first line direction for width
    resizeVec = normVec(lines[0].from, lines[0].to);
  } else if (direction === 'depth') {
    // Use perpendicular vector for depth
    const widthVec = normVec(lines[0].from, lines[0].to);
    resizeVec = { x: -widthVec.y, y: widthVec.x }; // perpendicular vector
  } else {
    throw new Error('Direction must be "width" or "depth"');
  }

  // Calculate projections in resize direction
  const proj = pts.map(p => p.x * resizeVec.x + p.y * resizeVec.y);
  const minP = Math.min(...proj);
  const maxP = Math.max(...proj);
  const oldSize = maxP - minP;
  const centerP = (minP + maxP) / 2;

  // Calculate how much we need to expand
  const sizeDifference = newSize - oldSize;
  const halfExpansion = sizeDifference / 2;

  pts.forEach((p, i) => {
    if (proj[i] < centerP) {
      // Point is on the first side - move it away from center
      p.x -= resizeVec.x * halfExpansion;
      p.y -= resizeVec.y * halfExpansion;
    } else if (proj[i] > centerP) {
      // Point is on the second side - move it away from center
      p.x += resizeVec.x * halfExpansion;
      p.y += resizeVec.y * halfExpansion;
    }
    // Points exactly at center don't move
  });
}
